import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
    <!-- Contextual Button -->
  <div class="contextual-btn-container">
    <wa-button
        id="btnContextual"
        size="small"
        class="contextual-btn">
        <slot name="start"></slot>
        <slot name="buttonText"></slot>
        <slot name="end"></slot>
    </wa-button>
  </div>
`
class NavHeaderContextualButton extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    
  }
}

customElements.define('ts-navheader-contextual-button', NavHeaderContextualButton)
